import common from '@cloudpivot/common';
export default common.directives.controlBack;
